import { atom } from "recoil";

export const historyModeState = atom({
  key: 'historyModeState',
  default: false
});
